import { default as repos } from './repos/routes.js';
import { default as tables } from './tables/routes.js';

export default [...repos, ...tables];
